import * as React from "react";

export interface LayoutProps {
    children?: React.ReactNode;
}

export class Layout extends React.Component<LayoutProps, {}> {
    public render() {
        return <div className='container-fluid'>
            <div>
                <div style={{ width: '100%' }}>
                    {this.props.children}
                </div>
            </div>
        </div>;
    }
}
